module.exports = __webpack_public_path__ + "images/6c05bdaa337d8ee920524df9da0ac6c1.png";